import { LogLevel } from '@azure/msal-browser';
import { XhrClient } from './XhrClient';
/**
 * Gets a default configuration object, based on the given arguments.
 *
 * `redirectPath` is just the path part of the redirectUri, and should not have an initial slash.
 * The full redirectUri will be built up based on `window.location.origin`.
 */

export function getDefaultConfiguration(authority, signInPolicyPath, clientId, redirectPath, navigationClient) {
  var isIE = typeof window !== 'undefined' && window.navigator.userAgent.indexOf('Trident/') !== -1;
  var origin = typeof window !== 'undefined' ? window.location.origin : '';
  var config = {
    auth: {
      clientId,
      authority: authority + '/' + signInPolicyPath,
      knownAuthorities: [authority],
      redirectUri: "".concat(origin, "/").concat(redirectPath),
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: isIE
    },
    system: {
      navigationClient,
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }

          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;

            case LogLevel.Info:
              console.info(message);
              return;

            case LogLevel.Verbose:
              console.debug(message);
              return;

            case LogLevel.Warning:
              console.warn(message);
              return;

            default:
          }
        },
        logLevel: LogLevel.Warning
      }
    }
  };
  /*
   * One of things the MSAL library does is fetches the openid-configuration.
   * When it comes back, it has an Access-Control-Allow-Origin header set
   * to the domain you are requesting it from, and a Cache-Control header
   * set to 'private'. This should mean that if you request the config from a
   * different domain, it should re-request the config.
   *
   * Unfortunately, IE11 thinks that sub-domains are the same domain for the
   * sake of caching, so when you request the config from the wales-england
   * domain then again from wales-welsh domain, it gives you the cached
   * version the second time. This shouldn't be a problem, as the content is
   * identical.
   *
   * Unfortunately, IE11 thinks that sub-domains are different domains for
   * sake of CORS, and so it then rejects its own cached copy of the config.
   *
   * So if we're using IE11, replace the default XhrClient with one we have
   * modified to send cache-busting headers with every GET request.
   *
   * See https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/2974
   */

  if (isIE) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    config.system.networkClient = new XhrClient();
  }

  return config;
}